(function () {
    'use strict';

    angular
        .module('app.filterTypes')
        .controller('FilterTypeDetailController', FilterTypeDetailController);

    FilterTypeDetailController.$inject = [
        '$state', '$stateParams',
        'bootstrap.dialog', 'common', 'dataservice', 'config'
    ];

    function FilterTypeDetailController($state, $stateParams,
        bsDialog, common, dataservice, config) {
        /*jshint validthis: true */
        var vm = this;
        var logger = common.logger;
        var $q = common.$q;
        vm.counts = [];
        vm.cancel = cancel;
        vm.deleteItem = deleteItem;
        vm.isSaving = false;
        vm.save = save;
        vm.filters = undefined;
        vm.isNew = isNew;
        vm.preventDelete = preventDelete;
        vm.eventTypeLabel = "Event Types";
        vm.categoryLabel = "Categories";
        vm.roomTypeLabel = "Room Types";
        vm.buildingsLabel = "Buildings";
        vm.showBuildingsFilter = true;
        vm.showViewsFilter = true;
        vm.showUdfsFilter = true;

        vm.filterData = {
            Buildings: [],
            Statuses: [],
            Categories: [],
            EventTypes: [],
            RoomTypes: [],
            Views: [],
            Users: [],
            Udfs: []
        };
        vm.filters = {
            buildings: [],
            statuses: [],
            categories: [],
            eventTypes: [],
            roomTypes: [],
            views:[],
            userIds: [],
            udfs: []
        }
        
        
        activate();

        function activate() {
            setDisplayForApiType();
            var promises = [common.checkIsAdmin(), initLookups(), getItem(), getCounts()];
            return common.$q.all(promises).then(function (data) {
                
            }, function (error) { });
        }

        function cancel() {
            backToList();
        }

        function backToList() {
            $state.go("filtertypes.list");
        }

        function setDisplayForApiType() {
            var apiType = common.userService.apiTypeId();
            switch (apiType) {
                case config.apiTypes.collegeNet:
                    vm.showViewsFilter = false;
                    vm.eventTypeLabel = "Event Types";
                    vm.categoryLabel = "Resources Categories";
                    vm.roomTypeLabel = "Location Categories";
                    vm.buildingsLabel = "Location Partitions";
                    break;
                case config.apiTypes.sevenPoint:
                    vm.showUdfsFilter = true;
                    break;
                case config.apiTypes.mazevo:
                    vm.showViewsFilter = false;
                    vm.showUdfsFilter = false;
                    break;
            }
        }

        function preventDelete() {
            if (vm.counts.length > 0 || $stateParams.id <= 0) {
                return true;
            }
            
            return false;
        }

        function deleteItem() {
            return bsDialog.deleteDialog('Filter Type')
                .then(confirmDelete, function () { });

            function confirmDelete() {
                dataservice.deleteItem("api/FilterTypes/" + vm.filters.ID).then(success).catch(failed);

                function success() {
                    backToList();
                }

                function failed(error) {
                    logger.error(error);
                }
            }
        }

        function isNew() {
            var val = $stateParams.id; 
            return val === "-1";
        }

        function getCounts() {
            if($stateParams.id > 0) {
                return dataservice.getItems('api/FilterTypes/CountsOfUsersWithFilterType/' + $stateParams.id).then(function (response) {
                    vm.counts = response.data;
                    return vm.counts;
                }, function (error) { });
            }
            else {
                vm.counts = { ActiveCount: 0, Name: -1 };
            }
        }

        function getItem() {
            var val = $stateParams.id;
            if (val === '-1') {
                vm.filters = {};
                vm.filters.ID = -1;
                vm.filters.Active = 1;
                vm.filters.highlightChangesWithin = 1440;
                vm.filters.includeBookingWithCategoriesOnly = 0;
                vm.filters.showReservedTimes = 1;
                vm.filters.buildings = [];
                vm.filters.statuses = [];
                vm.filters.categories = [];
                vm.filters.eventTypes = [];
                vm.filters.roomTypes = [];
                vm.filters.userIds = [];
                vm.filters.views = [];
                vm.filters.udfs = [];
              
                common.setAuditInfo(vm.filters);
                return vm.item;
            }

            return dataservice.getItem("api/FilterTypes/" + val)
                .then(function (data) {
                    if (data) {
                        var d = data.data;
                        if (d.FilterData) {
                            vm.filters = angular.fromJson(atob(d.FilterData));
                            if (!vm.filters.roomTypes) {
                                vm.filters.roomTypes = [];
                            }
                            if (!vm.filters.eventTypes) {
                                vm.filters.eventTypes = [];
                            }
                            if (!vm.filters.views) {
                                vm.filters.views = [];
                            }
                            if (!vm.filters.udfs) {
                                vm.filters.udfs = [];
                            }
                        }
                        else {
                            vm.filters.highlightChangesWithin = 1440;
                            vm.filters.Active = 1;
                        }
                        
                        vm.filters.ID = d.ID;
                        vm.filters.Description = d.Description;
                        vm.filters.AddedBy = d.AddedBy;
                        vm.filters.DateAddedUtc = d.DateAddedUtc;
                        vm.filters.DateChangedUtc = d.DateChangedUtc;
                        vm.filters.ChangedBy = d.ChangedBy;
                        vm.filters.userIds = d.UserIds;
                        vm.filters.IsUserConfigurable = d.IsUserConfigurable;
                        common.setAuditInfo(vm.filters);
                        //not sure why we were doing this here, but it can cause a problem where some filters are getting dates inputed in their values
                      //  common.convertDateStringsToDates(vm.filters);
                        
                    } else {
                        logger.warning('Could not find item with id = ' + val);
                        $state.go('404');
                    }
                })
                .catch(function (error) {
                 //   logger.error('Error while getting item with id = ' + val + '; ' + error);
                 //   $state.go('404');
                });
        }


        function initLookups() {
            dataservice.getItems('api/DailySetup/GetFilters').then(function (response) {
                var data = response.data;
                var roomChargeIndex = data.Categories.indexOf("2147483647");
                if (roomChargeIndex > -1) {
                    data.Categories.splice(roomChargeIndex, 1);
                }
                vm.filterData.Buildings = data.Buildings;
                vm.filterData.Statuses = data.Statuses;
                vm.filterData.Categories = data.Categories;
                vm.filterData.EventTypes = data.EventTypes;
                vm.filterData.RoomTypes = data.RoomTypes;
                vm.filterData.Views = data.Views;
                vm.filterData.Udfs = data.Udfs;
                return;
            }, function (error) { });
            dataservice.getItems('api/Users/GetActive').then(function (response) {
                var data = response.data;
                vm.filterData.Users = data;
                return;
            }, function (error) { });
        }

        function save() {
            vm.isSaving = true;

            var roomChargeIndex = vm.filters.categories.indexOf("2147483647");
            if (roomChargeIndex > -1) {
                vm.filters.categories.splice(roomChargeIndex, 1);
            }

            vm.filters.filterData = btoa(angular.toJson(vm.filters));

            dataservice.saveItem('api/FilterTypes', vm.filters).then(function (saveResult) {
                vm.isSaving = false;
                backToList();
            }).catch(function (error) {
                vm.isSaving = false;
            });
        }
    }
})();
